const GroupList = {
  'pages_group_management': '그룹관리',
  'pages_group_info': '그룹 정보',
  'pages_group_change_name': '그룹명 변경',
  'pages_group_invite_group': '그룹 초대',
  'pages_group_comapny_name': '회사명',
  'pages_group_user_name': '사용자명',
  'pages_group_user_email': '이메일주소(ID)',
  'pages_group_user_status': '상태',
  'pages_group_user_admin_yn': '관리자 권한 설정',
  'pages_group_user_admin_func': '관리자 기능',
  'pages_group_user_secession': '탈퇴',
  'pages_group_user_permission': '가입처리',
  'pages_group_user_unknown': '모름',
  'pages_group_user_approval': '승인',
  'pages_group_invite': '초대',
  'pages_group_user_wait_approval': '승인대기',
  'pages_group_user_deny': '거절',
  'pages_group_name': '그룹명',
  'pages_group_invite_user_name': '이름',
  'pages_group_invite_user_email': '이메일주소',
  'pages_group_change_name_update_success': '그룹명이 수정되었습니다',
  'pages_group_invite_user': '그룹에 초대 하였습니다',
  'pages_group_change_name_update': '그룹명을 수정하겠습니까?',
  'pages_group_change_name_require': '그룹명을 입력하여 주세요',
  'pages_group_invite_user_last_name': '성',
  'pages_group_invite_user_first_name': '이름',
  'pages_group_invite_user_last_name_require': '성을 입력하여 주세요',
  'pages_group_invite_user_first_name_require': '이름을 입력하여 주세요',
  'pages_group_invite_user_company_name': '회사명',
  'pages_group_invite_user_company_name_require': '회사명을 입력하여 주세요',
  'pages_group_invite_user_email_require': '이메일을 입력하여 주세요',
  'pages_group_user_secession_confirm': '해당 사용자를 탈퇴 시키겠습니까?',
  'pages_group_user_secession_ok': '해당 사용자를 탈퇴 시켰습니다',
  'pages_group_user_invite_user': '해당 사용자를 그룹에 초대 하겠습니까?',
  'pages_group_user_invite_user_ok': '해당 사용자를 그룹에 초대 하였습니다',
  'pages_group_user_find': '사용자 조회',
  'pages_group_user_email_not': '이메일을 정확히 입력하여 주세요',
  'pages_group_user_approve': '가입 승인',
  'pages_group_user_companion': '반려',
  'pages_group_user_approve_q': '해당 사용자를 승인 하겠습니까?',
  'pages_group_user_approve_ok': '해당 사용자를 승인 하였습니다',
  'pages_group_user_companion_q': '해당 사용자를 반려 하겠습니까?',
  'pages_group_user_companion_ok': '해당 사용자를 반려 하였습니다',
  'pages_group_user_admin_appoint': '관리자 지정',
  'pages_group_user_admin_delete': '관리자 해제',
  'pages_group_user_admin_no': '관리자 아님',
  'pages_group_user_admin': '관리자',
  'pages_group_user_admin_delete_not': '관리자가 1명이하 이기 때문에 관리자 권한을 해제할 수 없습니다',
  'pages_group_user_admin_delete_no': '관리자가 1 명이기 때문에 탈퇴시킬 수 없습니다',
  'pages_group_user_admin_refund': '해당 회원의 승인상태가 반려이기 때문에\n 관리자로 지정할 수 없습니다 ',
  'pages_group_user_admin_refund_wait': '해당 회원의 승인상태가 승인대기 이기 때문에\n 관리자로 지정할 수 없습니다 ',
  'pages_group_user_admin_delete_ok': '관리자 해제하였습니다',
  'pages_group_user_admin_delete_q': '관리자 해제하겠습니까?',
  'pages_group_user_admin_appoint_q': '관리자로 지정 하시겠습니까?',
  'pages_group_user_admin_appoint_ok': '관리자로 지정 하였습니다',
  'pages_group_user_new_user_q': '시용자가 없습니다.\n 사용자를 가입 시키겠습니까?',
  'pages_group_user_new_user_ok': '사용자를 가입 시켰습니다',
  'pages_group_user_approve_popup': '가입 승인 처리',
  'pages_group_user_exist': '그룹에 해당회원이 이미 있습니다',
  'pages_group_user_del_exist': '그룹에 해당회원이 없습니다',
  'pages_group_del_user_del_self': '자신을 탈퇴시킬 수 없습니다',
  'pages_group_ready': '준비중입니다',


  /*          Group App List            */
  'pages_group_app_management': '앱관리',
  'pages_group_app_name': '앱이름',
  'pages_group_app_info': '설명',
  'pages_group_app_status': '상태',
  'pages_group_app_change': '앱 사용 관리 기능',
  'pages_group_app_used': '사용중',
  'pages_group_app_not_used': '사용하지 않음',
  'pages_group_app_used_button': '사용',
  'pages_group_app_not_used_button': '사용하지 않음',
  'pages_group_app_await': '승인 처리중',
  'pages_group_delete_app_await': '삭제 처리중',
  'pages_group_not_used_ask': '앱을 사용하지 않으시겠습니까?',
  'pages_group_not_used': '앱을 사용 하시겠습니까?',

}

export default GroupList



// WEBPACK FOOTER //
// ./src/lang/group/GroupList.kr.js